import { IFetchConfig } from "@elsa-zku/lib/helpers/fetch";
import fetch from "./http-client";

import { DisableNotification, DisableNotificationBuilding } from "./data-contracts";

export const disableNotificationsControllerFindBuilding = (buildingId: number, params?: IFetchConfig) =>
  fetch<{
    data: DisableNotificationBuilding;
  }>("GET", `v1/disable-notifications/${buildingId}`, null, params);

export const disableNotificationsControllerFindDisableNotifications = (
  buildingId: number,
  query: {
    year: number;
    number?: string;
  },
  params?: IFetchConfig,
) =>
  fetch<{
    data: DisableNotification[];
  }>("GET", `v1/disable-notifications/${buildingId}/notifications`, query, params);
